/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState, useEffect, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useMutation, ServerError, useLazyQuery } from '@apollo/client'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { fetchStart, fetchStop } from '../../../../redux/actions/common'
import mutations from '../../../../setup/graphql/mutations'
import query from '../../../../setup/graphql/query'
import Alert from '../../../../_metronic/partials/alert'
import { setApplicationComplete, setCoApplicant } from '../redux/actions'
import { privacyPolicy } from '../../../../_metronic/helpers'
import { toStr } from '../../../modules/loanApplication/steps/Step3'
import PhoneInput from 'react-phone-number-input'
import { RightAeroIcon } from '../../../../svg/RightAeroIcon'
import { cleanFileNameDynamic } from '../../../../constants/commonFunctions'
import { Popover, Stack } from 'react-bootstrap'
import { OverlayTrigger } from 'react-bootstrap-v5'
import { UploadIcon } from '../../../../svg/UploadIcon'
import { Xicon } from '../../../../svg/Xicon'

const Step1Sub3: FC<any> = ({ getCoApplicant }) => {
  const dispatch = useDispatch()
  const history: any = useHistory()

  localStorage.removeItem('singpass')

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg, setAlertMsg] = useState<string>('')
  const [alertType, setAlertType] = useState<any>('primary')
  // const [information, setInformation] = useState<any>(null);
  const [fileGroup, setFileGroup] = useState<any>([])
  const [saveUserData, onSaveUserData] = useMutation(mutations.CREATE_EXTERNAL_DATA_STORE)
  const [updateCoApplicant, onUpdateCoApplicant] = useMutation(mutations.UPDATE_SHAREHOLDER_KYC)
  const [fetchBrigs, onSuccessFetchBrigs] = useLazyQuery(query.FETCH_BRIGS_DATA)
  const [createFileStorage, onSuccessCreateFileStorage] = useMutation(mutations.CREATE_FILE_STORAGE)
  const [deleteFileStorage] = useMutation(mutations.DELETE_FILE_STORAGE)
  const [getApplication, { data: applicationData }] = useLazyQuery(query.GET_APPLICATION)

  const companyVerificationMethod = useSelector(
    (state: any) => state.coApplicant.companyVerificationMethod
  )

  // Ref for scrolling to consent checkbox when there's an error
  const consentBoxRef = useRef<HTMLDivElement>(null)
  // const coapplicant = useSelector((state: any) => state.coApplicant.co_applicant);
  const rawPerson = useSelector((state: any) => state.coApplicant.personData)
  const person = useMemo(() => {
    const info =
      rawPerson?.personInfo?.person_info ??
      (rawPerson?.personInfo?.uinfin || rawPerson?.personInfo?.['noa-basic']
        ? rawPerson.personInfo
        : undefined) ??
      rawPerson?.person_info ??
      (rawPerson?.uinfin || rawPerson?.['noa-basic'] ? rawPerson : undefined)
    if (!info) return rawPerson
    const noas = getNoaList(info)
    return {
      ...info,
      ownerprivate:
        info.ownerprivate && typeof info.ownerprivate === 'object'
          ? { ...info.ownerprivate, value: String(info.ownerprivate.value ?? '') }
          : { value: String(info.ownerprivate ?? '') },
      noahistory: { noas },
    }
  }, [rawPerson])

  const hasValue = (value: any) => {
    if (value === undefined || value === null) return false
    const s = String(value).trim().toLowerCase()
    return !['', 'na', 'n/a', 'unavailable', 'undefined'].includes(s)
  }

  function getNoaList(p: any) {
    if (p?.noahistory?.noas?.length) return p.noahistory.noas
    const noa = p?.['noa-basic'] || p?.['noaBasic'] || p?.['noa']
    if (!noa) return []
    return [
      {
        amount: noa.amount?.value ?? noa.amount,
        yearofassessment: noa.yearofassessment?.value ?? noa.yearofassessment,
      },
    ]
  }

  const coApplicationId = localStorage.getItem('coApplicationId')
  const coApplicant = useSelector((state: any) => state.coApplicant.co_applicant)

  useEffect(() => {
    if (coApplicant == null) {
      getCoApplicant({
        variables: { shareholderId: localStorage.getItem('coApplicationId') },
      })
    }
  }, [])

  useEffect(() => {
    if (coApplicant?.application?.id) {
      getApplication({
        variables: { appId: coApplicant.application.id, mobileNumber: '' },
      })
    }
  }, [coApplicant])
  useEffect(() => {
    if (onSaveUserData.called && !onSaveUserData.loading) {
      if (onSaveUserData.data) {
        if (coApplicant.isGuarantor) {
          fetchBrigs({
            variables: {
              coApplicationId: coApplicationId,
            },
          })
        } else {
          updateCoApplicant({
            variables: {
              where: {
                id: coApplicationId,
              },
              data: {
                ...(companyVerificationMethod === 2
                  ? { dataViaSingpass: false, creationType: 'manual' }
                  : {}),
                experianConsent: false,
                kycStatus: 'completed',
              },
            },
          })
        }
      }

      if (onSaveUserData.error) {
        const { networkError } = onSaveUserData.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [onSaveUserData.data, onSaveUserData.error, onSaveUserData.loading])

  useEffect(() => {
    if (onSuccessFetchBrigs.called && !onSuccessFetchBrigs.loading) {
      if (onSuccessFetchBrigs.data) {
        updateCoApplicant({
          variables: {
            where: {
              id: coApplicationId,
            },
            data: {
              ...(companyVerificationMethod === 2
                ? { dataViaSingpass: false, creationType: 'manual' }
                : {}),
              experianConsent: true,
              kycStatus: 'completed',
            },
          },
        })
      }

      if (onSuccessFetchBrigs.error) {
        const { networkError } = onSuccessFetchBrigs.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [onSuccessFetchBrigs.data, onSuccessFetchBrigs.error, onSuccessFetchBrigs.loading])

  useEffect(() => {
    if (onUpdateCoApplicant.called && !onUpdateCoApplicant.loading) {
      if (onUpdateCoApplicant.data) {
        dispatch(fetchStop())
        dispatch(setCoApplicant(onUpdateCoApplicant.data.updateShareholderKycStatus))
        dispatch(setApplicationComplete(true))
        history.push(`/co-applicant-nets-kyc/completed`)
      }

      if (onUpdateCoApplicant.error) {
        const { networkError } = onUpdateCoApplicant.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [onUpdateCoApplicant.data, onUpdateCoApplicant.error, onUpdateCoApplicant.loading])

  const initialValues: any = useMemo(
    () => ({
      uinfin: person?.uinfin?.value ?? '',
      name: person?.name?.value ?? '',
      sex: person?.sex?.desc ?? '',
      // race: person.race.desc,
      nationality: person?.nationality?.desc ?? '',
      dob: person?.dob?.value ?? '',
      email: person?.email?.value ?? '',
      mobileno: person
        ? `${person?.mobileno?.prefix?.value}${person?.mobileno?.areacode?.value}${person?.mobileno?.nbr?.value}`
        : '',
      // regadd: person ? `${person.regadd.block?.value} ${person.regadd.building?.value} ${person.regadd.floor?.value} ${person.regadd.unit?.value} ${person.regadd.street?.value} ${person.regadd.postal?.value}` : '',
      regadd: person ? toStr(person.regadd, 'ADDRESSLOCAL') : '',
      // housingtype: `${person.housingtype.desc} ${person.hdbtype.desc}`,
      // marital: person.marital.desc,
      // edulevel: person.edulevel.desc,
      residentialstatus: person?.residentialstatus?.desc ?? '',
      birthcountry: person?.birthcountry?.desc ?? '',
      occupation: person?.occupation?.value ?? '',
      employment: person?.employment?.value ?? '',
      passportnumber: person?.passportnumber?.value ?? '',
      passportexpirydate: person?.passportexpirydate?.value ?? '',
      passtype: person?.passtype?.desc ?? '',
      passstatus: person?.passstatus?.value ?? '',
      passexpirydate: person?.passexpirydate?.value ?? '',
      hdbtype: person?.hdbtype?.desc ?? '',
      ownerprivate: person?.ownerprivate?.value ?? '',
      noahistory: getNoaList(person),
      confirmCheckbox: false,
      promotionalMarketingCheckbox: false,
    }),
    [person]
  )
  const getValidationSchema = () => {
    // When companyVerificationMethod === 1, bypass validation for most fields
    if (companyVerificationMethod === 1) {
      return Yup.object().shape({
        uinfin: Yup.string(),
        name: Yup.string().matches(
          /^[a-zA-Z\s,*]+$/,
          'Name can only contain letters, spaces, and commas'
        ),
        sex: Yup.string(),
        nationality: Yup.string(),
        dob: Yup.string(),
        email: Yup.string().required('Email Address is required').email('Enter Valid Email'),
        mobileno: Yup.string()
          .min(11, 'Enter Valid Mobile Number')
          .max(11, 'Enter Valid Mobile Number')
          .required('Mobile Number is required'),
        regadd: Yup.string(),
        residentialstatus: Yup.string(),
        ownerprivate: Yup.string(),
        confirmCheckbox: Yup.bool().oneOf([true], 'Please consent to above mandatory terms'),
      })
    }

    // Default validation schema for other verification methods
    return Yup.object().shape({
      uinfin: Yup.string().test('no-only-spaces', 'NRIC/FIN cannot be just spaces', (value) =>
        value ? value.trim().length > 0 : true
      ),
      name: Yup.string().test('no-only-spaces', 'Name cannot be just spaces', (value) =>
        value ? value.trim().length > 0 : true
      ),
      sex: Yup.string().test('no-only-spaces', 'Sex cannot be just spaces', (value) =>
        value ? value.trim().length > 0 : true
      ),
      nationality: Yup.string().test(
        'no-only-spaces',
        'Nationality cannot be just spaces',
        (value) => (value ? value.trim().length > 0 : true)
      ),
      dob: Yup.string()
        .test('format-or-year', 'Date format must be YYYY-MM-DD', (value: any) => {
          if (!value) return true
          // Allow either YYYY-MM-DD or just YYYY
          return /^\d{4}(-\d{2}-\d{2})?$/.test(value)
        })
        .test('is-valid-date', 'Please enter a valid date', (value: any) => {
          if (!value) return true

          // If only year is provided (e.g., "1967"), append -01-01
          let dateStr = value
          if (/^\d{4}$/.test(value)) {
            dateStr = `${value}-01-01`
          }

          // Parse the date and check if it's valid
          const date = new Date(dateStr)
          if (isNaN(date.getTime())) return false

          // Verify that the parts match what was actually set
          // This catches cases like 2021-02-31 which would be converted to 2021-03-03 silently

          const [year, month, day] = dateStr.split('-').map(Number)
          const parsedDate = new Date(date)

          return (
            parsedDate.getFullYear() === year &&
            parsedDate.getMonth() + 1 === month &&
            parsedDate.getDate() === day
          )
        })
        .test('not-future', 'Date of Birth cannot be in the future', (value: any) => {
          if (!value) return true

          // If only year is provided, append -01-01
          let dateStr = value
          if (/^\d{4}$/.test(value)) {
            dateStr = `${value}-01-01`
          }

          const date = new Date(dateStr)

          return !isNaN(date.getTime()) && date <= new Date()
        }),
      email: Yup.string()
        .required('Email Address is required')
        .email('Enter Valid Email')
        .test('no-only-spaces', 'Email cannot be just spaces', (value) =>
          value ? value.trim().length > 0 : true
        ),
      mobileno: Yup.string()
        .min(11, 'Enter Valid Mobile Number')
        .max(11, 'Enter Valid Mobile Number')
        .required('Mobile Number is required')
        .test('no-only-spaces', 'Mobile Number cannot be just spaces', (value) =>
          value ? value.trim().length > 0 : true
        ),
      regadd: Yup.string().test(
        'no-only-spaces',
        'Registered Address cannot be just spaces',
        (value) => (value ? value.trim().length > 0 : true)
      ),
      residentialstatus: Yup.string().test(
        'no-only-spaces',
        'Residential Status cannot be just spaces',
        (value) => (value ? value.trim().length > 0 : true)
      ),
      ownerprivate: Yup.string()
        .required('Owner Private is required')
        .test('no-only-spaces', 'Owner Private cannot be just spaces', (value) =>
          value ? value.trim().length > 0 : true
        ),
      confirmCheckbox: Yup.bool().oneOf([true], 'Please consent to above mandatory terms'),
    })
  }

  const validationSchema = getValidationSchema()

  //eslint-disable-next-line
  const removeSingleFile = async (id: string) => {
    const _fileGroup = fileGroup.filter((o: any) => o.id !== id)
    setFileGroup(_fileGroup)
    await deleteFileStorage({
      variables: {
        where: { id: id },
      },
    })
  }

  const isValidFile = (event: any, fileTypes: string[], docType: string = '') => {
    const excelTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-excel', // .xls
      'application/octet-stream', // Some Excel files might have this type
      'application/zip', // .xlsx is actually a zip file
    ]

    const isExcelFile = (file: File) => {
      const fileName = file.name.toLowerCase()
      return (
        excelTypes.includes(file.type) ||
        fileName.endsWith('.xlsx') ||
        fileName.endsWith('.xls') ||
        file.type === ''
      ) // Sometimes Excel files might not have a type
    }

    const isPdfFile = (file: File) => {
      return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
    }

    const isValidType = (file: File) => {
      if (fileTypes.includes('application/pdf') && isPdfFile(file)) return true
      if (
        (fileTypes.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
          fileTypes.includes('application/vnd.ms-excel')) &&
        isExcelFile(file)
      )
        return true
      return fileTypes.includes(file.type)
    }

    const checkType = [...event.target.files].some((file: File) => !isValidType(file))

    if (checkType) {
      const docTypeDisplay = getDocTypeDisplay(docType)

      setShowAlert(true)
      setAlertMsg(`Please upload a valid ${docTypeDisplay}`)
      setAlertType('primary')
      // Clear the file input
      event.target.value = ''
      event.target.files = null
      return false
    }
    return true
  }

  const getDocTypeDisplay = (docType: string): string => {
    switch (docType) {
      case 'identity-proof':
        return 'Identity Proof'
      case 'credit-bureau-singapore-document':
        return 'Credit Bureau Singapore Document'
      case 'mlcb-report':
        return 'MLCB Report'
      case 'noa-document':
        return 'NOA Document'
      default:
        return 'File'
    }
  }

  //eslint-disable-next-line
  const handleFileUpload = (event: any, type: string, fileType: string[] = ['application/pdf']) => {
    if (event.target.validity.valid) {
      let files = []
      let uploadDocs = []

      const isValid = isValidFile(event, fileType, type)

      if (!isValid) return

      for (let file of event.target.files) {
        const isExists = fileGroup.some(
          (f: any) =>
            cleanFileNameDynamic(f.file.filename) === cleanFileNameDynamic(file.name) &&
            f.type === type
        )

        if (!isExists) {
          file.filename = file.name
          files.push({ type: type, file })
          uploadDocs.push({
            shareholderKycStatus: {
              connect: {
                id: coApplicationId,
              },
            },
            fileType: type,
            documentFile: {
              upload: file,
            },
            updatedByUserName: coApplicant?.personName ?? formik?.values?.name,
          })
        } else {
          event.target.value = ''
          setShowAlert(true)
          setAlertMsg('File already exists')
          setAlertType('primary')
          return
        }
      }

      if (files.length) {
        event.target.value = ''
        createFileStorage({
          variables: {
            data: uploadDocs,
          },
        })
        event.target.value = ''
        dispatch(fetchStart())
      }
    }
  }

  useEffect(() => {
    if (onSuccessCreateFileStorage.called && !onSuccessCreateFileStorage.loading) {
      dispatch(fetchStop())
      if (onSuccessCreateFileStorage.data) {
        if (onSuccessCreateFileStorage.data) {
          const { createFileStorages } = onSuccessCreateFileStorage.data
          let file = [...fileGroup]
          for (const document of createFileStorages) {
            const _file = {
              id: document.id,
              type: document.fileType,
              file: document.documentFile,
            }
            file.push(_file)
          }

          setFileGroup(file)

          onSuccessCreateFileStorage.reset()
        }
      } else {
      }

      if (onSuccessCreateFileStorage.error) {
        const { networkError } = onSuccessCreateFileStorage.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
      }
    }
  }, [
    onSuccessCreateFileStorage.loading,
    onSuccessCreateFileStorage.data,
    onSuccessCreateFileStorage.error,
    onSuccessCreateFileStorage.called,
  ])

  function fileGroupValidation() {
    // Check if NOA document is required (amount >= 25000)
    const isNOADocumentRequired =
      applicationData?.getLatestApplication?.approvedDetails?.approvedAmount >= 25000

    // If NOA document is required, check if it's uploaded
    if (isNOADocumentRequired) {
      const hasNOADocument = fileGroup.some((file: any) => file.type === 'noa-document')
      if (!hasNOADocument) {
        return false
      }
    }

    return true
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    onSubmit: (values: any, { setStatus, setSubmitting }: any) => {
      if (coApplicationId) {
        dispatch(fetchStart())
        // Normalize dob: if only year is provided, append -01-01
        const normalizedValues = { ...values }
        if (normalizedValues.dob && /^\d{4}$/.test(normalizedValues.dob)) {
          normalizedValues.dob = `${normalizedValues.dob}-01-01`
        }
        saveUserData({
          variables: {
            data: {
              shareholderKycStatus: {
                connect: {
                  id: coApplicationId,
                },
              },
              //TODO: add data fetched from singpass or manual entry here
              type: 'singpass',
              data: normalizedValues,
              // dataCreatedAt: new Date().toISOString()
            },
          },
        })
        setSubmitting(false)
      }
    },
  })

  useEffect(() => {
    formik.setValues(initialValues, false)
  }, [initialValues])

  // Add effect to scroll to consent box when validation fails
  useEffect(() => {
    // Check if there's a checkbox error and the form has been submitted
    if (
      formik?.submitCount > 0 &&
      formik?.errors?.confirmCheckbox &&
      !formik?.values?.confirmCheckbox &&
      consentBoxRef?.current
    ) {
      // Scroll the consent box into view with smooth behavior
      consentBoxRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [formik?.submitCount, formik?.errors?.confirmCheckbox, formik?.values?.confirmCheckbox])

  return (
    <div className='d-flex flex-column flex-column-fluid w-100'>
      <div className='notice d-flex banner text-start p-6 mb-5'>
        <div className='d-flex flex-stack flex-grow-1'>
          <div>
            <h2>User Profile</h2>
            <div className='fs-3'>
              The following details have been provided to us by MyInfo Singpass
            </div>
          </div>
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className='cardNew'>
          <div className='section-heading'></div>
          <h2>Personal Information</h2>
          <hr className='text-gray-400' />
          <div className='row'>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                UINFIN
              </label>
              <div className='col-sm-12'>
                <input
                  name='uinfin'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.uinfin}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.uinfin && formik.errors.uinfin && (
                  <div className='text-danger mt-2'>{formik.errors.uinfin}</div>
                )}
              </div>
            </div>

            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Name
              </label>
              <div className='col-sm-12'>
                <input
                  name='name'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.name && formik.errors.name && (
                  <div className='text-danger mt-2'>{formik.errors.name}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Sex
              </label>
              <div className='col-sm-12'>
                <input
                  name='sex'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.sex}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.sex && formik.errors.sex && (
                  <div className='text-danger mt-2'>{formik.errors.sex}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Date of birth
              </label>
              <div className='col-sm-12'>
                <input
                  name='dob'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.dob}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {(formik.touched.dob || formik.errors.dob === undefined) && formik.errors.dob && (
                  <div className='text-danger mt-2'>{formik.errors.dob}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Mobile number
              </label>
              <div className='col-sm-12'>
                <PhoneInput
                  id='mobileno'
                  international
                  defaultCountry='SG'
                  value={formik.values.mobileno}
                  onChange={(value) => formik.setFieldValue('mobileno', value)}
                  onBlur={() => formik.setFieldTouched('mobileno', true)}
                  className='int-phone-input rounded-top rounded-bottom'
                />
                {formik.touched.mobileno && formik.errors.mobileno && (
                  <div className='text-danger mt-2'>{formik.errors.mobileno}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Email
              </label>
              <div className='col-sm-12'>
                <input
                  name='email'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={companyVerificationMethod === 1}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className='text-danger mt-2'>{formik.errors.email}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Nationality
              </label>
              <div className='col-sm-12'>
                <input
                  name='nationality'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.nationality}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.nationality && formik.errors.nationality && (
                  <div className='text-danger mt-2'>{formik.errors.nationality}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Residential Status
              </label>
              <div className='col-sm-12'>
                <input
                  name='residentialstatus'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.residentialstatus}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.residentialstatus && formik.errors.residentialstatus && (
                  <div className='text-danger mt-2'>{formik.errors.residentialstatus}</div>
                )}
              </div>
            </div>

            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Registered Address
              </label>
              <div className='col-sm-12'>
                <input
                  name='regadd'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.regadd}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.regadd && formik.errors.regadd && (
                  <div className='text-danger mt-2'>{formik.errors.regadd}</div>
                )}
              </div>
            </div>
            {hasValue(formik.values.birthcountry) && (
              <div className='col-md-6 mb-5'>
                <label htmlFor='' className='input-field-label'>
                  Birth Country
                </label>
                <div className='col-sm-12'>
                  <input
                    name='birthcountry'
                    type='text'
                    className='form-control form-control-solid'
                    value={formik.values.birthcountry}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={companyVerificationMethod === 1}
                  />
                  {formik.touched.birthcountry && formik.errors.birthcountry && (
                    <div className='text-danger mt-2'>{formik.errors.birthcountry}</div>
                  )}
                </div>
              </div>
            )}
            {hasValue(formik.values.occupation) && (
              <div className='col-md-6 mb-5'>
                <label htmlFor='' className='input-field-label'>
                  Occupation
                </label>
                <div className='col-sm-12'>
                  <input
                    name='occupation'
                    type='text'
                    className='form-control form-control-solid'
                    value={formik.values.occupation}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={companyVerificationMethod === 1}
                  />
                  {formik.touched.occupation && formik.errors.occupation && (
                    <div className='text-danger mt-2'>{formik.errors.occupation}</div>
                  )}
                </div>
              </div>
            )}
            {hasValue(formik.values.employment) && (
              <div className='col-md-6 mb-5'>
                <label htmlFor='' className='input-field-label'>
                  Employment
                </label>
                <div className='col-sm-12'>
                  <input
                    name='employment'
                    type='text'
                    className='form-control form-control-solid'
                    value={formik.values.employment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={companyVerificationMethod === 1}
                  />
                  {formik.touched.employment && formik.errors.employment && (
                    <div className='text-danger mt-2'>{formik.errors.employment}</div>
                  )}
                </div>
              </div>
            )}
            {hasValue(formik.values.passportnumber) && (
              <div className='col-md-6 mb-5'>
                <label htmlFor='' className='input-field-label'>
                  Passport Number
                </label>
                <div className='col-sm-12'>
                  <input
                    name='passportnumber'
                    type='text'
                    className='form-control form-control-solid'
                    value={formik.values.passportnumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={companyVerificationMethod === 1}
                  />
                  {formik.touched.passportnumber && formik.errors.passportnumber && (
                    <div className='text-danger mt-2'>{formik.errors.passportnumber}</div>
                  )}
                </div>
              </div>
            )}
            {hasValue(formik.values.passportexpirydate) && (
              <div className='col-md-6 mb-5'>
                <label htmlFor='' className='input-field-label'>
                  Passport Expiry Date
                </label>
                <div className='col-sm-12'>
                  <input
                    name='passportexpirydate'
                    type='text'
                    className='form-control form-control-solid'
                    value={formik.values.passportexpirydate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={companyVerificationMethod === 1}
                  />
                  {formik.touched.passportexpirydate && formik.errors.passportexpirydate && (
                    <div className='text-danger mt-2'>{formik.errors.passportexpirydate}</div>
                  )}
                </div>
              </div>
            )}
            {hasValue(formik.values.passtype) && (
              <div className='col-md-6 mb-5'>
                <label htmlFor='' className='input-field-label'>
                  Pass Type
                </label>
                <div className='col-sm-12'>
                  <input
                    name='passtype'
                    type='text'
                    className='form-control form-control-solid'
                    value={formik.values.passtype}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={companyVerificationMethod === 1}
                  />
                  {formik.touched.passtype && formik.errors.passtype && (
                    <div className='text-danger mt-2'>{formik.errors.passtype}</div>
                  )}
                </div>
              </div>
            )}
            {hasValue(formik.values.passstatus) && (
              <div className='col-md-6 mb-5'>
                <label htmlFor='' className='input-field-label'>
                  Pass Status
                </label>
                <div className='col-sm-12'>
                  <input
                    name='passstatus'
                    type='text'
                    className='form-control form-control-solid'
                    value={formik.values.passstatus}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={companyVerificationMethod === 1}
                  />
                  {formik.touched.passstatus && formik.errors.passstatus && (
                    <div className='text-danger mt-2'>{formik.errors.passstatus}</div>
                  )}
                </div>
              </div>
            )}
            {hasValue(formik.values.passexpirydate) && (
              <div className='col-md-6 mb-5'>
                <label htmlFor='' className='input-field-label'>
                  Pass Expiry Date
                </label>
                <div className='col-sm-12'>
                  <input
                    name='passexpirydate'
                    type='text'
                    className='form-control form-control-solid'
                    value={formik.values.passexpirydate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={companyVerificationMethod === 1}
                  />
                  {formik.touched.passexpirydate && formik.errors.passexpirydate && (
                    <div className='text-danger mt-2'>{formik.errors.passexpirydate}</div>
                  )}
                </div>
              </div>
            )}
            {hasValue(formik.values.hdbtype) && (
              <div className='col-md-6 mb-5'>
                <label htmlFor='' className='input-field-label'>
                  HDB Type
                </label>
                <div className='col-sm-12'>
                  <input
                    name='hdbtype'
                    type='text'
                    className='form-control form-control-solid'
                    value={formik.values.hdbtype}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={companyVerificationMethod === 1}
                  />
                  {formik.touched.hdbtype && formik.errors.hdbtype && (
                    <div className='text-danger mt-2'>{formik.errors.hdbtype}</div>
                  )}
                </div>
              </div>
            )}
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Owner Private
              </label>
              <div className='col-sm-12'>
                <input
                  name='ownerprivate'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.ownerprivate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.ownerprivate && formik.errors.ownerprivate && (
                  <div className='text-danger mt-2'>{formik.errors.ownerprivate}</div>
                )}
              </div>
            </div>
            <div className='col-md-12 mb-5'>
              <label className='input-field-label'>NOA History</label>
              {formik.values.noahistory?.length ? (
                <div className='row'>
                  {formik.values.noahistory.map((noa: any, idx: number) => (
                    <div key={idx} className='col-md-6 mb-3'>
                      <div className='p-3 border rounded'>
                        <div className='mb-2'>
                          <strong>Year of Assessment:</strong> {noa.yearofassessment}
                        </div>
                        <div>
                          <strong>Amount:</strong> {noa.amount}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className='text-muted'>No NOA history available</div>
              )}
            </div>
            {/* files upload */}
            {applicationData?.getLatestApplication?.approvedDetails?.approvedAmount >= 25000 && (
              <div className='col-md-6 mb-5'>
                <div className='mb-2 d-flex align-items-center'>
                  <label
                    htmlFor=''
                    style={{ fontSize: '16px', fontWeight: 500 }}
                    className='input-field-label required mb-0'
                  >
                    NOA Document
                  </label>
                  &nbsp;
                  <OverlayTrigger
                    trigger='hover'
                    placement='right'
                    overlay={
                      <Popover>
                        <Popover.Body
                          style={{
                            backgroundColor: '#202020',
                            color: 'white',
                            borderRadius: '10px',
                            padding: '15px',
                          }}
                        >
                          Upload the NOA document.
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <svg
                      width='14'
                      height='14'
                      viewBox='0 0 14 14'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7 5H7.00667M6.33333 7H7V9.66667H7.66667M1 7C1 7.78793 1.15519 8.56815 1.45672 9.2961C1.75825 10.0241 2.20021 10.6855 2.75736 11.2426C3.31451 11.7998 3.97595 12.2417 4.7039 12.5433C5.43185 12.8448 6.21207 13 7 13C7.78793 13 8.56815 12.8448 9.2961 12.5433C10.0241 12.2417 10.6855 11.7998 11.2426 11.2426C11.7998 10.6855 12.2417 10.0241 12.5433 9.2961C12.8448 8.56815 13 7.78793 13 7C13 5.4087 12.3679 3.88258 11.2426 2.75736C10.1174 1.63214 8.5913 1 7 1C5.4087 1 3.88258 1.63214 2.75736 2.75736C1.63214 3.88258 1 5.4087 1 7Z'
                        stroke='#787878'
                        stroke-width='1.5'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                      />
                    </svg>
                  </OverlayTrigger>
                </div>
                <span
                  className='fw-bold mb-7'
                  style={{
                    fontSize: '14px',
                    display: 'inline-block',
                    lineHeight: '1.1',
                    color: '#19147B',
                  }}
                >
                  Please upload the NOA document.
                </span>
                <div
                  className='uploadBoxCoApp'
                  style={{
                    border: '1px dashed #BBBFC4',
                    padding: '63px 40px',
                    background: 'rgba(26,3,85,0.02)',
                    minHeight: '150px',
                    fontSize: '14px',
                    marginBottom: '15px',
                    borderRadius: '10px',
                    alignItems: 'center',
                  }}
                  onDrop={(e: React.DragEvent) => {
                    e.preventDefault()
                    e.stopPropagation()
                    const files = e.dataTransfer.files
                    if (files.length) {
                      const event = { target: { files, validity: { valid: true } } }
                      handleFileUpload(event, 'noa-document', ['application/pdf'])
                    }
                  }}
                  onDragOver={(e: React.DragEvent) => {
                    e.preventDefault()
                    e.stopPropagation()
                  }}
                  onDragLeave={(e: React.DragEvent) => {
                    e.preventDefault()
                    e.stopPropagation()
                  }}
                >
                  <Stack
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    gap={2} // Increased gap for better spacing
                  >
                    <div className='upload mb-4'>
                      <input
                        id='upload-noa-documents'
                        type='file'
                        multiple
                        accept='application/pdf'
                        onChange={(e: any) =>
                          handleFileUpload(e, 'noa-document', ['application/pdf'])
                        }
                        onDrop={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                          const files = e.dataTransfer.files
                          if (files.length) {
                            const event = { target: { files, validity: { valid: true } } }
                            handleFileUpload(event, 'noa-document', ['application/pdf'])
                          }
                        }}
                        onDragOver={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                        onDragLeave={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                      ></input>
                      <label
                        htmlFor='upload-noa-documents'
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <div
                          className='file-uploader'
                          style={{
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          <UploadIcon color='var(--primary-color)' />

                          <span className='dragDropTitle'>Drag & Drop NOA Document</span>
                        </div>
                        <div className='file-uploader-sub'>Supported formats: PDF</div>
                      </label>
                    </div>
                  </Stack>
                </div>
                <div className='uploadedCapsulesWrap'>
                  <Stack
                    className='uploadedCapsules gridCapsules'
                    style={{
                      display: 'grid', // Change to grid layout
                      gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
                      gap: '12px', // Adjusted gap for better spacing
                      fontSize: '12px',
                      minWidth: '100%',
                    }}
                  >
                    {fileGroup && fileGroup.length > 0 && (
                      <>
                        {fileGroup
                          .filter(({ type }: any) => type === 'noa-document')
                          .map(({ file, type, id }: any, i: number) => {
                            const filename = file.filename.split('.')
                            const name = filename[0].substring(0, 10)
                            const extension = filename[1]

                            return (
                              <div
                                key={i}
                                style={{
                                  fontSize: 14,
                                  color: '#616B75',
                                  background: '#F9FAFA',

                                  border: '1px solid #E0E0E0',
                                  padding: '8px 16px',
                                  display: 'flex', // Use flex to position items
                                  justifyContent: 'space-between', // Space between text and icon
                                  alignItems: 'center', // Center items vertically
                                  width: '100%', // Set to 100% to fill the grid cell
                                }}
                                title={file.filename}
                              >
                                <span>{`${name}...${extension}`}</span>
                                <Xicon
                                  onClick={() => removeSingleFile(id)}
                                  className='cursor-pointer'
                                />
                              </div>
                            )
                          })}
                      </>
                    )}
                  </Stack>
                </div>
              </div>
            )}
          </div>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <div className='cardNew' style={{ marginBottom: '0px' }}>
            <div className='section-heading'>
              <h2>PG/Shareholder Consent</h2>
              <hr className='text-gray-400' />
            </div>
            <div>
              <label className='form-check form-check-inline form-check-solid me-5'>
                <input
                  name='confirmCheckbox'
                  type='checkbox'
                  id='form-check-input'
                  className={`form-check-input ${
                    (formik.submitCount > 0 || formik.errors.confirmCheckbox) &&
                    !formik.values.confirmCheckbox
                      ? 'is-invalid'
                      : ''
                  }`}
                  checked={formik.values.confirmCheckbox}
                  onChange={formik.handleChange}
                />
                <span className='ps-2 fs-4 text-justified'>
                  <b>By submitting this information, I hereby:</b> <br />
                  <ul className='text-justify gap-4 mt-4'>
                    <li className='mb-4'>
                      Confirm that all information provided is accurate, complete and correct.
                    </li>

                    <li className={'mb-4'}>
                      I hereby give my consent to CrediLinq A.I. Pte. Ltd. (CrediLinq), its
                      affiliates and partners, to consult with credit bureaus and relevant
                      government institutions to collect, share, and exchange my personal and
                      business data for purposes of the loan application process in accordance to
                      their privacy policy available [
                      <a
                        href={privacyPolicy()}
                        style={{ fontWeight: 500, textDecoration: 'underline', color: '#19147B' }}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        here
                      </a>
                      ].
                    </li>
                  </ul>
                </span>
              </label>

              <label className='form-check form-check-inline form-check-solid me-5 mt-4'>
                <input
                  name='promotionalMarketingCheckbox'
                  type='checkbox'
                  id='form-check-input'
                  className={`form-check-input`}
                  checked={formik.values.promotionalMarketingCheckbox}
                  onChange={formik.handleChange}
                />
                <span className='ps-2 fs-4 text-justified'>
                  I agree to receive marketing and promotional materials from CrediLinq via email,
                  SMS, phone calls, and other communication channels.
                </span>
              </label>
            </div>
          </div>
        </div>
        <div className='text-danger border-text'>
          {formik.errors.confirmCheckbox && <div>{formik.errors.confirmCheckbox}</div>}
        </div>

        <div className='cardNew stickeyFooter'>
          <div className='d-flex flex-end'>
            <button
              type='submit'
              className='button button-primary '
              disabled={
                // Disable if:
                // 1. For company verification method 2: all 3 file types must be uploaded
                // 2. For company verification method 1: only credit bureau document is required
                // 3. Or if form is not valid or submitting
                !fileGroupValidation() || !formik.isValid || formik.isSubmitting
              }
            >
              Submit KYC <RightAeroIcon color='currentColor' />
            </button>
          </div>
        </div>
      </form>

      {showAlert && (
        <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
          {alertMsg}
        </Alert>
      )}
    </div>
  )
}

export { Step1Sub3 }
